import { useContext } from 'react';

import {
  CustomerAuthContext,
  type CustomerAuthContextValue,
} from '../customerAuthContext';

export function useCustomerAuth(): CustomerAuthContextValue {
  const context = useContext(CustomerAuthContext);
  if (!context) {
    throw new Error('useCustomerAuth must be used inside <CustomerAuthProvider>');
  }
  return context;
}
